function onReady(callback) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", callback, { once: true });
  } else {
    callback();
  }
}

onReady(() => {
  const $ = window.jQuery;
  if (!$) return;

  function formatDate(date) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
    return `${date.getDate()} de ${monthNames[date.getMonth()]}`;
  }

  function buildComment(review) {
    return `
      <div class="reviews-item">
        <div class="reviews-item-box">
          <div class="reviews-item-title">
            <div class="reviews-rating">
              <i class="reviews-star"></i>
              <p class="reviews-qualification">${Math.round(parseFloat(review.general))}</p>
            </div>
          </div>
          <p class="reviews-item-date show-for-mobile-only">${formatDate(new Date(review.created_at))}</p>
        </div>
        <div class="reviews-item-content">
          <p class="reviews-item-comment" data-comment="${review.comments}">${review.comments}</p>
        </div>
        <p class="reviews-item-date hide-for-mobile-only">${formatDate(new Date(review.created_at))}</p>
      </div>
    `;
  }

  $(".show-more").on("click", function () {
    const parent = $(this).closest(".reviews-item-content").find(".reviews-item-comment");
    parent.text(parent.data("comment"));
    $(this).remove();
  });

  $(".reviews-pagination-button").on("click", function () {
    const pagination = $("#commentsPagination");
    let currentPage = Number(pagination.data("currentpage"));
    const totalPages = Number(pagination.data("totalpages"));
    const action = pagination.data("action");

    currentPage += $(this).hasClass("next") ? 1 : -1;
    currentPage = Math.max(1, Math.min(totalPages, currentPage));

    pagination.data("currentpage", currentPage);

    $.getJSON(`${action}${currentPage}`, (reviews) => {
      const htmlComments = reviews.map(buildComment).join("");
      $(".reviews-item-container").html(htmlComments);

      $("html, body").animate(
        {
          scrollTop: $("#comentarios").offset().top,
        },
        600
      );

      $("#currentPage").html(currentPage);
    });
  });
});
